import React, { createContext, useEffect, useState } from "react";

const OceanOnBoardingContext = createContext();

const OceanProvider = ({ children }) => {
  const [oceanID, setOceanID] = useState(0);







  return (
    <OceanOnBoardingContext.Provider
      value={{
     
        oceanID,
        setOceanID,
      }}
    >
      {children}
    </OceanOnBoardingContext.Provider>
  );
};

export { OceanOnBoardingContext, OceanProvider };
